import useProxy from './useProxy';

export default function API() {
  const proxy = useProxy();

  return {
    getProjectsAutoUser: (onSuccess, onFailure) => proxy.run('getProjectsAutoUser', null, onSuccess, onFailure),
    getProjectsForPm: (params, onSuccess, onFailure) => proxy.run('getProjectsForPm', params, onSuccess, onFailure),
    getProjectsForPgm: (params, onSuccess, onFailure) => proxy.run('getProjectsForPgm', params, onSuccess, onFailure),
    updateProject: (params, onSuccess, onFailure) => proxy.run('updateProject', params, onSuccess, onFailure),
    updateProjectRow: (params, onSuccess, onFailure) => proxy.run('updateProjectRow', params, onSuccess, onFailure),
    getCurrentUserJson: (onSuccess, onFailure) => proxy.run('getCurrentUserJson', null, onSuccess, onFailure),
    getPms: (onSuccess, onFailure) => proxy.run('getPms', null, onSuccess, onFailure),
    createUser: (params, onSuccess, onFailure) => proxy.run('createUser', params, onSuccess, onFailure),
    getPgmArea: (params, onSuccess, onFailure) => proxy.run('getPgmArea', params, onSuccess, onFailure),
    addNewProject: (params, onSuccess, onFailure) => proxy.run('addNewProject', params, onSuccess, onFailure),
    allPgmAreas: (params, onSuccess, onFailure) => proxy.run('allPgmAreas', params, onSuccess, onFailure),
    allPgTypes: (onSuccess, onFailure) => proxy.run('allPgTypes', null, onSuccess, onFailure),
    getLogoList: (onSuccess, onFailure) => proxy.run('getLogoList', null, onSuccess, onFailure),
    getLogo: (params, onSuccess, onFailure) => proxy.run('getLogo', params, onSuccess, onFailure),
    editProjectRow: (params, onSuccess, onFailure) => proxy.run('editProjectRow', params, onSuccess, onFailure),
    allUtilisations: (onSuccess, onFailure) => proxy.run('allUtilisations', null, onSuccess, onFailure),
  };
}
